import { render, staticRenderFns } from "./AssetResources.vue?vue&type=template&id=4c8c7df2&scoped=true"
import script from "./AssetResources.vue?vue&type=script&lang=js"
export * from "./AssetResources.vue?vue&type=script&lang=js"
import style0 from "./AssetResources.vue?vue&type=style&index=0&id=4c8c7df2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8c7df2",
  null
  
)

export default component.exports